import React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-modern text-black text-center">
    
        <h1 className="text-5xl font-bold text-red-600 mb-4">404</h1>
        <h2 className="text-2xl font-semibold">{t('Page not found')}</h2>
        <p className="text-lg text-gray-600 px-4 mt-2">{t('It looks like you\'ve taken a wrong turn.')}</p>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
